<template lang="pug">
.calendar_cell
  .time_zone(v-if='getTimeZone') {{ getTimeZone }}
  .cell_text_wrap(v-if='getCellFromData.object_name')
    .rootText.time_zone {{ getCellFromData.object_name }}
  transition(name='fade')
    .cell_text_wrap(v-if='getCellFromData.lesson && open')
      .rootText Занятие:
      .valueText {{ getCellFromData.lesson }}
  transition(name='fade')
    .cell_text_wrap(v-if='getCellFromData.expert_name && open')
      .rootText Преподаватель:
      .valueText {{ getCellFromData.expert_name }}
  transition(name='fade')
    .cell_text_wrap(v-if='getCellFromData.partner_name && open')
      .rootText Организация:
      .valueText {{ getCellFromData.partner_name }}
</template>

<script>
export default {
  name: 'CalendarCell',
  props: {
    day: String,
    data: {},
    rowCount: Number,
    open: Boolean,
  },
  computed: {
    getCellFromData() {
      let data = Object.entries(this.data).find(elem => {
        return elem[0] === this.day;
      });
      if (data && data[1] && data[1][this.rowCount]) {
        return data[1][this.rowCount];
      }
      return {};
    },
    getTimeZone() {
      let data = this.getCellFromData;
      if (data.time_from && data.time_to) {
        return `${data.time_from} - ${data.time_to}`;
      }
      return '';
    },
  },
};
</script>

<style scoped lang="stylus">
.cell_text_wrap
  padding-top 3px
.rootText
  font-weight bold
.calendar_cell
  width 14.28571%;
  min-height 40px;
  display flex
  flex-direction column
  border-right 1px solid #aaaaaa;
  word-wrap: break-word;
  font-size: 12px;
  padding: 1px;
  .time_zone
    background-color: #242c58;
    color: #fafafb;
    font-weight: bold;
    width: max-content;
    max-width: 100%;
</style>


// WEBPACK FOOTER //
// CalendarCell.vue?405e5b28